<div class="spinner-center">
  <c11n-spinner *ngIf="!datasets[0].data.length && !infoNotAvailable " colorMode="on-light" size="large" spinnerStatus="Loading..."></c11n-spinner>
</div>
<div>
  <div class="toggle-container">
      <c11n-segmented-control size="small" color="ink"
      legendText="Chart/Table Toggle" (stateChange)="onChange($event)" class="quarterly-toggle-width">
      <c11n-segment id="Chart" labelText="Chart">
          <input c11n-segment-input type="radio" id="chart" name="segment-group" [value]="'chart'" checked>
      </c11n-segment>
      <c11n-segment id="Table" labelText="Table">
          <input c11n-segment-input type="radio" id="table" name="segment-group" [value]="'table'" data-rpa-tag-id="pr-hp-tab-table">
      </c11n-segment>
  </c11n-segmented-control>
  </div>

<div *ngIf="displayToggle=='chart'">
<div class="container historical-price-wrap" *ngIf="datasets[0].data.length;else noData">
    <span>
      <div>
        <div>
            <table >
              <thead>
                  <tr>
                      <th><span>Name</span></th>
                      <th><span>Date</span></th>
                      <th><span>NAV</span></th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td><span data-rpa-tag-id="symbol">
                          {{profileData.ticker}}
                          </span>
                      </td>
                      <td *ngIf="greaterThan(chartIndex)" >
                        <span data-rpa-tag-id="historicalDate">
                        {{chatLabels[chartIndex]}}
                        </span>
                    </td>
                    <td *ngIf="chartIndex===undefined ">
                      <span>
                      {{currentDate}}
                      </span>
                  </td>
                  <td  class="" *ngIf="greaterThan(chartIndex)" >
                    <div class="legend">

                      <div class=" legend-box legend-common legend-first"></div>
                      <span data-rpa-tag-id="priceNAV">{{datasets[0].data[chartIndex] | currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                    </td>
                    <td class="legend" *ngIf="chartIndex===undefined ">
                      <div class="legend">
                        <div class=" legend-box legend-common legend-first"></div>
                        <span>{{currentHistoricalPrice | currency:'USD':'symbol':'1.2-2' }}</span>
                      </div>
                    </td>

                  </tr>
              </tbody>
              </table>
        </div>
      </div>
    </span>
    <div class="">
      <div class="col-lg-12 line-chart">
        <app-line-chart ariaLabel="A line graph that depicts historical price information" *ngIf="datasets[0].data.length;else noData" [dataset]="datasets" [labels]="chatLabels" (chartMouseOut)="chartMouseOut()" (activeItemChanged)="activeItemChanged($event)"></app-line-chart>
      </div>
      </div>
  </div>

  <ng-template #noData>
    <p *ngIf="!noShowLoader">Please wait while Loading</p>
    <p *ngIf="infoNotAvailable" class="no-data">This information is temporarily unavailable.</p>
  </ng-template>
</div>

<div class="row" *ngIf="displayToggle=='table'">
  <div class="horizontal-scroll-table" *ngIf="historicalTableData.length>0;else noData">
    <table class="table-results table-hover" aria-label="Historical prices table">
            <thead>
                <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Price</th>
                    <th scope="col" class="spacer" aria-hidden="true"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of historicalTableData">
                    <td data-rpa-tag-id="historicalDate">{{data?.asOfDate | ESTPipe}}</td>
                    <td data-rpa-tag-id="historicalPrice">${{data.price}}</td>
                    <td class="spacer" aria-hidden="true"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="table-bottom">
      <div class="table-index pagination-view container-fluid" [ngClass]="{'flex-row-reverse':!isMobileDevice,'flex-column':isMobileDevice}">
        <vmf-pagination [paginationLabel]="modelLabel" (newPageNumber)="setPageNumber($event)"  [listSize]="tableData.length"></vmf-pagination>
      </div>
    </div>

  </div>
  <ng-template #noData>
    <p *ngIf="!noShowLoader">Please wait while Loading</p>
    <p *ngIf="infoNotAvailable" class="no-data">This information is temporarily unavailable.</p>
  </ng-template>
  </div>
